// Frontend quest catalog — mirrors backend/quests_meta.py. Plus icon component map.
import {
  Sparkles,
  DoorOpen,
  Swords,
  TestTube,
  Users,
  Hammer,
  BadgeDollarSign,
  PhoneCall,
  UserPlus,
  Wallet,
  TrendingUp,
  Banknote,
  Crown,
} from "lucide-react";

export const TOTAL_QUESTS = 13;
export const MAX_QUEST_ID = 12;

export const QUEST_META = [
  { id: 0, title: "What's Your Founder Face?", subtitle: "30-second persona reveal.", part: "Prologue", icon: "Sparkles", xp: 100, free: true },
  { id: 1, title: "Escape Your 9-5", subtitle: "The ONE thing keeping you in your job.", part: "Part 1 · Mindset", icon: "DoorOpen", xp: 200, free: true },
  { id: 2, title: "Find Your Unfair Advantage", subtitle: "What you have that 99% don't.", part: "Part 1 · Mindset", icon: "Swords", xp: 250, free: false },
  { id: 3, title: "Validate Without Spending", subtitle: "Prove the idea before you build it.", part: "Part 2 · Build", icon: "TestTube", xp: 250, free: false },
  { id: 4, title: "Your First 100 Customers", subtitle: "Hand-to-hand distribution.", part: "Part 2 · Build", icon: "Users", xp: 350, free: false },
  { id: 5, title: "Build a Minimum Lovable Product", subtitle: "Lovable beats viable.", part: "Part 2 · Build", icon: "Hammer", xp: 350, free: false },
  { id: 6, title: "Pricing Like a Founder", subtitle: "Charge what it's worth, not what it costs.", part: "Part 3 · Sell", icon: "BadgeDollarSign", xp: 400, free: false },
  { id: 7, title: "Sales Calls That Convert", subtitle: "Sell without sounding salesy.", part: "Part 3 · Sell", icon: "PhoneCall", xp: 400, free: false },
  { id: 8, title: "Hire Your First Team", subtitle: "The first 3 hires decide everything.", part: "Part 3 · Sell", icon: "UserPlus", xp: 400, free: false },
  { id: 9, title: "Tame the Cash Flow Beast", subtitle: "Profit is opinion. Cash is fact.", part: "Part 3 · Sell", icon: "Wallet", xp: 350, free: false },
  { id: 10, title: "The Growth Loop", subtitle: "Compounding > virality.", part: "Part 3 · Sell", icon: "TrendingUp", xp: 500, free: false },
  { id: 11, title: "Raising Capital", subtitle: "When to raise — and when not to.", part: "Part 3 · Sell", icon: "Banknote", xp: 500, free: false },
  { id: 12, title: "Scale or Sell", subtitle: "The founder's final choice.", part: "Part 3 · Sell", icon: "Crown", xp: 600, free: false },
];

export const ICON_MAP = {
  Sparkles, DoorOpen, Swords, TestTube, Users, Hammer,
  BadgeDollarSign, PhoneCall, UserPlus, Wallet, TrendingUp, Banknote, Crown,
};

export const XP_MAP = QUEST_META.reduce((acc, q) => ({ ...acc, [q.id]: q.xp }), {});

export const PARTS_ORDER = ["Prologue", "Part 1 · Mindset", "Part 2 · Build", "Part 3 · Sell"];

export function questById(id) {
  return QUEST_META.find((q) => q.id === Number(id)) || null;
}

export function scoreLabel(score) {
  if (score == null) return null;
  if (score >= 85) return { label: "Elite Founder", color: "text-amber-400" };
  if (score >= 70) return { label: "Strong Founder", color: "text-emerald-400" };
  if (score >= 55) return { label: "Emerging Founder", color: "text-orange-400" };
  return { label: "Early Stage", color: "text-zinc-400" };
}
